export var RNRenderer = {
    findHostInstance_DEPRECATED: function(_ref) {
        return null;
    }
};
